import type { ProductCardsConfig } from '@iheartjane/types';

export const MOBILE_PRODUCT_CARD_WIDTH = 162;

export const PRODUCT_CARD_SIZE_MAP: Record<
  ProductCardsConfig['card_size'],
  number
> = {
  small: 190,
  medium: 225,
  large: 290,
};
